import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import FileProtectOutlinedSvg from "@ant-design/icons-svg/es/asn/FileProtectOutlined";
import AntdIcon from "../components/AntdIcon";
var FileProtectOutlined = function FileProtectOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FileProtectOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  FileProtectOutlined.displayName = 'FileProtectOutlined';
}
export default /*#__PURE__*/React.forwardRef(FileProtectOutlined);